(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abc-hoodie-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      root.querySelectorAll('[data-hoodie-view-column]').forEach((gallery) => {
        if (gallery.dataset.viewGalleryReady) return;
        const controls = gallery.querySelector('.abc-hoodie-pair__thumbnails');
        const stage = gallery.querySelector('.abc-hoodie-pair__view');
        if (!controls || !stage) return;
        const panels = Array.from(gallery.querySelectorAll('[data-view-panel]'));
        const buttons = Array.from(controls.querySelectorAll('[data-view-choice]'));
        gallery.dataset.viewGalleryReady = 'true';
        const ready = new Set(['0']);
        const mouseHover = window.matchMedia('(hover: hover) and (pointer: fine)');
        let selected = '0';
        let hovering = false;
        const render = () => {
          const visible = hovering && ready.has('1') ? '1' : selected;
          panels.forEach((panel) => { panel.hidden = panel.dataset.viewPanel !== visible; });
          buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.viewChoice === visible)));
        };
        const choose = (key) => {
          if (!ready.has(key)) return;
          selected = key;
          hovering = false;
          render();
        };
        const endHover = () => {
          hovering = false;
          render();
        };
        buttons.forEach((button) => button.addEventListener('click', () => choose(button.dataset.viewChoice)));
        stage.addEventListener('pointerenter', (event) => {
          if (!mouseHover.matches || event.pointerType !== 'mouse') return;
          hovering = true;
          render();
        });
        stage.addEventListener('pointerleave', endHover);
        stage.addEventListener('pointercancel', endHover);
        mouseHover.addEventListener('change', endHover);
        window.addEventListener('blur', endHover);
        const alternate = panels.find((panel) => panel.dataset.viewPanel === '1');
        const alternateImage = alternate && alternate.querySelector('img');
        if (!alternateImage) return;
        const prepareAlternate = async () => {
          if (!alternateImage.naturalWidth) return;
          try {
            await alternateImage.decode();
            ready.add('1');
            buttons.find((button) => button.dataset.viewChoice === '1').disabled = false;
            controls.hidden = false;
            render();
          } catch (_) {
            choose('0');
          }
        };
        alternateImage.addEventListener('load', prepareAlternate);
        alternateImage.addEventListener('error', () => {
          choose('0');
          ready.delete('1');
          buttons.find((button) => button.dataset.viewChoice === '1').disabled = true;
          controls.hidden = true;
        });
        if (alternateImage.complete) prepareAlternate();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
    } else {
      setup(document);
    }
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abc-hoodie-storefront"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepareBackImages = (root) => {
      root.querySelectorAll('.abc-hoodie-storefront__card-back img').forEach((image) => {
        if (image.dataset.preparing) return;
        image.dataset.preparing = 'true';
        const revealWhenDecoded = async () => {
          if (!image.naturalWidth) return;
          try {
            await image.decode();
            image.parentElement.setAttribute('data-ready', '');
          } catch (_) {
            // Keep the front visible if a back image cannot be decoded.
          }
        };
        image.addEventListener('load', revealWhenDecoded);
        if (image.complete) revealWhenDecoded();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => prepareBackImages(document), { once: true });
    } else {
      prepareBackImages(document);
    }
    document.addEventListener('shopify:section:load', (event) => prepareBackImages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
